import * as React from "react";
import { Loader } from "../../../organisms/common/loading";
import { displayGroupRole } from "../../../../application/domain/rbac/rbac";
import { useParams } from "react-router";
import { useEffect } from "react";
import {
  GroupUsersService,
  GroupUsersServiceProps,
} from "../../../../application/service/smart-apply/group-users/group-users-service";
import { connectPageService } from "../../../../application/domain/base/base-application-service";
import { SettingsTemplate } from "../../../template/settings/default-template";
import { SettingR } from "../route";
import { useAuthContextV2 } from "../../../../auth-state";
import { Redirect, useLocation, Link as RouterLink } from "react-router-dom";
import { convertToFormattedId } from "@graffer-inc/cloud-gov-core";
import { Pagination, Link } from "@graffer-inc/console-design-kit";
import { parseQueryOfLocation } from "../../../../utils/url-utils";

export const GroupUsers: React.FC<GroupUsersServiceProps> = ({
  isLoading,
  users,
  group,
  paging,
  setPage,
  movePage,
  onMountUsers,
}) => {
  const { auth } = useAuthContextV2();

  const { id } = useParams<{ id: string }>();
  const { page = "1" } = parseQueryOfLocation(useLocation()) as {
    page: string;
  };

  useEffect(() => {
    setPage(parseInt(page, 10));
    onMountUsers(id);
  }, [onMountUsers, id, page, setPage]);

  if (
    !auth.hasPermissions("groups.read") ||
    !auth.hasPermissions("users.read")
  ) {
    return <Redirect to={SettingR.MyAccount.link({})} />;
  }

  return (
    <SettingsTemplate
      breadcrumbs={[
        { to: SettingR.Groups.link({}), title: "グループ一覧" },
        {
          to: SettingR.GroupUsers.link({ id: id }),
          title: "グループユーザー一覧",
        },
      ]}
    >
      <h1 className="title">
        <i className="fa fa-tachometer" />
        {group.name}のユーザー一覧
      </h1>
      <Loader isLoading={isLoading}>
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>ユーザーID</th>
              <th>アカウント名</th>
              <th>氏名</th>
              <th>グループロール</th>
            </tr>
          </thead>
          <tbody>
            {users.map((a) => (
              <tr key={a.id} className="c-tr-has-tag">
                <td>
                  <Link
                    anchor={({ ...props }) => (
                      <RouterLink
                        {...props}
                        to={SettingR.UserDetail.link({ id: a.id })}
                      />
                    )}
                  >
                    {convertToFormattedId(a.id)}
                  </Link>
                </td>
                <td>{a.accountName}</td>
                <td>{a.name}</td>
                <td>{displayGroupRole(a.groupsRoles[group.id!])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Loader>
      <div style={{ marginTop: "16px" }}>
        <Pagination
          onPageClick={movePage}
          currentPage={paging.current}
          lastPage={paging.total}
        />
      </div>
    </SettingsTemplate>
  );
};

export const GroupUsersContainer = connectPageService(
  GroupUsers,
  () => new GroupUsersService(),
);
